module.exports = __webpack_public_path__ + "media/images/logos/gender-balance-logo-with-bg-2b69c5c7927112cdcd6ff2e4a9f7a134.svg";